export default __webpack_public_path__ + "static/media/promo_spatial_audio_billie_eilish_large.306cac4a.jpg";